import React from 'react';
import {injectIntl} from 'react-intl';
import Icon from 'components/Icon';
import {Button} from 'components/Button';
import {EmptyStateContainer, ButtonsContainer, TopSpacer} from './styles';
import {commonPalette} from 'styles/palette';
import {Typography as Text} from 'components/Text';

// https://www.figma.com/design/qPkZ8FQD8KMNkck1JugkJo/L2L-SwipeGuide-Design-System?node-id=7451-15846&m=dev
const EmptyStateComponent = props => {
  const {icon, title, description, buttonText, buttonAction, centered, topSpacer} = props;

  return (
    <EmptyStateContainer centered={centered}>
      {topSpacer && <TopSpacer data-testid="empty-state-top-spacer" />}
      {icon && <Icon name={icon} size={32} style={{marginBottom: '16px', color: commonPalette.iconDefault}} />}
      {title && (
        <Text as="h3" type="heading3" style={{marginBottom: '12px'}}>
          {title}
        </Text>
      )}
      {description}
      {buttonText && buttonAction && (
        <ButtonsContainer>
          <Button design={'outline'} onClick={buttonAction} style={{marginTop: '16px'}}>
            {buttonText}
          </Button>
        </ButtonsContainer>
      )}
    </EmptyStateContainer>
  );
};

export default injectIntl(EmptyStateComponent);
